import { createInstance } from './axios.api'
import {
  AuthenticationResponse,
  CollectStatusResponse
} from '@/types/authentication.types'

const STATUS_FAILED = 'Failed'
const STATUS_PENDING = 'Pending'

const axiosInstance = createInstance(process.env.VUE_APP_CIAM_URL, {
  withCredentials: true
})

const postRequest = async (url: string, data: any): Promise<any> => {
  const { data: responseData } = await axiosInstance.post(url, data)
  return responseData
}

const qRAuthenticate = async (): Promise<AuthenticationResponse> => {
  return postRequest('/v6/authentication', {})
}

const qRCollect = async (token: string): Promise<CollectStatusResponse> => {
  return postRequest('/v6/collect', { token })
}

const qRAuthCancel = async (token: string): Promise<AuthenticationResponse> => {
  return postRequest('/v6/cancel', { token })
}

const getJwt = async (): Promise<AuthenticationResponse> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL, {
    withCredentials: true
  })

  const { data } = await axios.post('/v6/renew')
  return data
}

export {
  qRAuthenticate,
  qRCollect,
  qRAuthCancel,
  STATUS_FAILED,
  STATUS_PENDING,
  getJwt
}
